import { _ } from "i18n";
import type { Keys } from "i18n/locales/types";
import { LoadMoreSection } from "./LoadMoreSection";

interface TableStatusProps {
	isLoading: boolean;
	showEmptyState: boolean;
	showEndOfList: boolean;
	shouldShowLoadMore: boolean;
	onLoadMore: () => void;
	isFetching: boolean;
}

export const TableStatus = ({ 
	isLoading, 
	showEmptyState, 
	showEndOfList, 
	shouldShowLoadMore, 
	onLoadMore,
	isFetching
}: TableStatusProps) => {
	if (isFetching) {
		return (
			<div className="table-status text-center p-4">
				<p>{_("video-tasks.table.fetching" as keyof Keys)}</p>
			</div>
		);
	}
	
	if (showEmptyState) {
		return (
			<div className="table-status text-center p-4">
				<p>{_("video-tasks.table.zero_records" as keyof Keys)}</p>
			</div>
		);
	}

	if (showEndOfList) {
		return (
			<div className="table-status text-center p-4">
				<p>{_("video-tasks.table.end_of_list" as keyof Keys)}</p>
			</div>
		);
	}

	if (!showEmptyState && !showEndOfList) {
		return (
			<div className="table-status">
				<LoadMoreSection
					isLoading={isLoading}
					shouldShowLoadMore={shouldShowLoadMore}
					onLoadMore={onLoadMore}
				/>
			</div>
		);
	}

	return null;
}; 